import { FindCustomerPayment, GenericApiResponse, paymetPayloadCustomer } from "interfaces";
import { SalesReport } from "interfaces/Sales";
import { post } from "services/services.methods";
import { FindPaymentCustomer, PaymentCustomer } from "services/services.paths";

export const PaymentToCustomer = (payload: paymetPayloadCustomer) => {
  const response = post<any>(PaymentCustomer.paymentToCustomer, payload);

  return response;
};


export const findpaymentToCustomer = async (
  purchaseParams: { customerId : number; dateFrom: string; dateTo: string;  }
): Promise<GenericApiResponse<FindCustomerPayment[]>> => {
  
  const url = `${FindPaymentCustomer.post}?customerId =${purchaseParams.customerId }&dateFrom=${purchaseParams.dateFrom}&dateTo=${purchaseParams.dateTo} }`;
  const response = await post<FindCustomerPayment[]>(FindPaymentCustomer.post, purchaseParams);


  return response;
};
